module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/zen-observable/index.js
// module id = 429
// module chunks = 17